import validate from "/var/www/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/var/www/node_modules/@backmarket/nuxt-layer-oauth/middleware/auth.global.ts";
import guest_45global from "/var/www/node_modules/@backmarket/nuxt-layer-oauth/middleware/guest.global.ts";
import log_45ds_45version_45global from "/var/www/node_modules/@backmarket/nuxt-layer-design-system/middleware/logDsVersion.global.ts";
import _01_45client_45side_45navigation_45global from "/var/www/node_modules/@backmarket/nuxt-layer-base/middleware/01.clientSideNavigation.global.ts";
import intercom_45global from "/var/www/apps/front-office/middleware/intercom.global.ts";
import logger from "/var/www/packages/nuxt-module-logger/src/runtime/middleware.ts";
import httpCache_46addCacheControlHeader from "/var/www/packages/nuxt-module-http-cache/src/runtime/middleware/addCacheControlHeader.ts";
import instrumentation_46setResourceName from "/var/www/packages/nuxt-module-instrumentation/src/runtime/middleware/setResourceName.ts";
import payment_45content_45security_45policies_45headers from "/var/www/packages/nuxt-layer-payment/scopes/content-security-policies/middleware/paymentContentSecurityPoliciesHeaders.global.ts";
export const globalMiddleware = [
  validate,
  auth_45global,
  guest_45global,
  log_45ds_45version_45global,
  _01_45client_45side_45navigation_45global,
  intercom_45global,
  logger,
  httpCache_46addCacheControlHeader,
  instrumentation_46setResourceName,
  payment_45content_45security_45policies_45headers
]
export const namedMiddleware = {
  "hide-consent-notice": () => import("/var/www/apps/front-office/middleware/hideConsentNotice.ts")
}